import { Button, Modal, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconUpload } from "@tabler/icons-react";
import WorkflowsListing from "./WorkflowsListing";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useUIStore } from "../../../../stores/UIStore";

const WorkflowListingModal = ({ nurturing }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  const navbarClosed = useUIStore((s) => s.navbarClosed);

  if (nurturing) {
    return (
      <>
        <Tooltip label={lang.campaign.import.label_tooltip}>
          <Button
            size="md"
            leftSection={<IconUpload size={18} />}
            variant="light"
            fw={400}
            radius={"md"}
            pos={"absolute"}
            bottom={120}
            left={16}
            onClick={open}
          >
            {lang.campaign.import.label}
          </Button>
        </Tooltip>

        {opened && (
          <Modal
            opened={opened}
            onClose={close}
            size={"90%"}
            withCloseButton={false}
          >
            <WorkflowsListing closeModal={close} nurturing />
          </Modal>
        )}
      </>
    );
  }

  return (
    <>
      <Tooltip label={lang.campaign.import.label_tooltip}>
        <Button
          size="md"
          leftSection={<IconUpload size={18} />}
          variant="light"
          fw={400}
          radius={"md"}
          pos={"absolute"}
          bottom={16}
          left={navbarClosed ? 96 + 172 : 256 + 172}
          onClick={open}
        >
          {lang.campaign.import.label}
        </Button>
      </Tooltip>

      {opened && (
        <Modal
          opened={opened}
          onClose={close}
          size={"90%"}
          withCloseButton={false}
        >
          <WorkflowsListing closeModal={close} />
        </Modal>
      )}
    </>
  );
};

export default WorkflowListingModal;
